import { Card, Modal, Typography, notification } from "antd";
import { PageHead } from "../components/PageHead.tsx";
import { Pending } from "../components/Pending.tsx";
import { useNavigate } from "@tanstack/react-router";
import { useFirstEffectIgnoreStrict } from "../helpers/useFirstEffect.tsx";
import { useState } from "react";
import { sleep } from "../helpers/Sleeper.ts";
import { useCreateRaid } from "./rest/RaidQueries.ts";
import { ensureCsrf } from "../api/csrfService.ts";
import { storePinForRaid } from "./pinStore.ts";

function CreateRaid() {
  const navigate = useNavigate();
  const [creating, setCreating] = useState(true);

  function navigateBack() {
    void navigate({ to: "/raids", replace: true });
  }

  const mutationCreation = useCreateRaid({
    onSuccess: (raid) => {
      storePinForRaid(raid.id, raid.adminPin);
      // notification (nicht message + contextHolder): nach navigate() wird CreateRaid
      // unmounted — der contextHolder verschwindet und die Message würde nicht erscheinen.
      notification.success({
        message: "Raid erstellt",
        description: (
          <Typography.Text copyable={{ text: raid.adminPin }}>
            Admin-PIN: {raid.adminPin}
          </Typography.Text>
        ),
        duration: 5,
      });
      void navigate({
        to: "/raids/$raidId/edit",
        params: { raidId: String(raid.id) },
        replace: true,
      });
    },
    onError: (status) => {
      setCreating(false);
      Modal.error({
        title: "Fehler beim erstellen",
        content: "Unerwarteter Fehler: " + status,
        onOk: () => navigateBack(),
      });
    },
  });

  useFirstEffectIgnoreStrict(() => {
    void (async () => {
      //console.log("login done");
      await ensureCsrf();
      await sleep(1000);
      const name = "Raid vom " + new Date().toISOString().split("T")[0];
      mutationCreation.mutate(name);
    })();
  });

  return (
    <div className={"w-full flex flex-col gap-4"}>
      {creating ? (
        <>
          <PageHead title={"Raid wird erstellt"}></PageHead>
          <Card>
            <div className={"flex flex-col w-full gap-4"}>
              <Typography.Paragraph className={"text-center"}>
                Bitte warten bis der Raid eingetragen ist. Du wirst dann zur
                Bearbeitung freigegeben
              </Typography.Paragraph>
              <Pending />
            </div>
          </Card>
        </>
      ) : (
        <>
          <PageHead title={"Raid wurde nicht erstellt"}></PageHead>
          <Card>
            <div className={"flex flex-col w-full gap-4"}>
              <Typography.Paragraph className={"text-center"}>
                Da ist was schief gelaufen.
              </Typography.Paragraph>
            </div>
          </Card>
        </>
      )}
    </div>
  );
}

export { CreateRaid };
